export default "assets/images/icons/slider-arrow-c7809e27.svg";